import React from "react";
import { ActivityIndicator, StyleSheet, Text, View } from "react-native";
import { useTranslation } from "react-i18next";
import { LmsLaunchSyncStatus } from "@axio/graphql/generated/graphql";

type LmsLaunchSetupViewProps = {
  status: LmsLaunchSyncStatus | undefined;
  failedReason?: string;
};

function LmsLaunchSetupView({ status, failedReason }: LmsLaunchSetupViewProps) {
  const { t } = useTranslation();

  const isFailed = status === "FAILED";
  const isLoading = !isFailed;

  return (
    <View style={styles.container}>
      <Text role="heading" aria-level={1} accessibilityRole="header" style={styles.heading}>
        {t("lmsLaunchSetup.settingUpAxio")}
      </Text>

      <Text style={styles.description}>{t("lmsLaunchSetup.settingUpDescription")}</Text>

      <View aria-live="polite" accessibilityLiveRegion="polite" style={styles.statusRegion}>
        {isLoading && (
          <ActivityIndicator size="large" color="#4F46E5" accessibilityLabel={t("lmsLaunchSetup.settingUpAxio")} />
        )}

        {isFailed && (
          <Text role="alert" accessibilityRole="alert" style={styles.errorText}>
            {failedReason ?? t("lmsLaunchSetup.errorMessage")}
          </Text>
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 32,
  },
  heading: {
    fontSize: 24,
    fontWeight: "700",
    textAlign: "center",
    marginBottom: 12,
    color: "#111827",
  },
  description: {
    fontSize: 16,
    textAlign: "center",
    color: "#6B7280",
    marginBottom: 32,
  },
  statusRegion: {
    minHeight: 48,
    alignItems: "center",
    justifyContent: "center",
  },
  errorText: {
    fontSize: 14,
    color: "#DC2626",
    textAlign: "center",
  },
});

export default LmsLaunchSetupView;
